import { TemplateNamespaceState, Actions, TemplateAction } from './types';

export const defaultState: TemplateNamespaceState = {
  value: '',
};

// The return type helps TypeScript to complain in this file if an action
// returns an invalid shape.
export function templateReducer(
  state: TemplateNamespaceState = defaultState,
  action: TemplateAction,
): TemplateNamespaceState {

  switch (action.type) {
    case Actions.Example:
      return {
        ...state,
        value: action.payload,
      };
    default:
      return state;
  }
}
